import { TextField } from '@mui/material'
import React from 'react'

export default function Input({
    label,
    placeholder,
    value,
    onChange,
    className,
    style,
    variant = "outlined",
    ...rest
}) {
    return (
        <div className={className}>
            <TextField
                style={style}
                fullWidth
                label={label}
                placeholder={placeholder}
                variant={variant}
                onChange={e => onChange(e.target.value)}
                value={value}
                {...rest}
            />
        </div>
    )
}
